import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface MinimaxI2v01DirectorParams {
  /**
   * 输入图像URL或Base64编码
   */
  first_frame_image: string;
  /**
   * 视频生成提示词，长度必须在0-2000个字符之间
   */
  prompt?: string;
  /**
   * 是否启用提示词优化器，默认为true
   */
  prompt_optimizer?: boolean;
}

export interface MinimaxI2v01DirectorResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * minimax_i2v_01_director
 *
 * MiniMax I2V-01-Director Image-to-Video Generator
 * 
 * Model: I2V-01-Director
 * Features: 图像生成视频 (Image-to-Video), 摄像机控制 (Camera Control)
 * Duration: 固定6秒
 * Resolution: 固定720P
 *
 * @example
 * ```typescript
 * import { initSeacloud, minimaxI2v01Director } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await minimaxI2v01Director({
 *   // 参数见 MinimaxI2v01DirectorParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 MinimaxI2v01DirectorParams 接口定义
 * @returns 生成的资源列表
 */
export async function minimaxI2v01Director(
  params: MinimaxI2v01DirectorParams,
): Promise<MinimaxI2v01DirectorResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 5000,
    maxAttempts: 120,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'minimax_i2v_01_director',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: MinimaxI2v01DirectorResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
